import Cookies from '../helpers/_Cookies';

export default function citiesChoice() {
  const citiesLinks = Array.prototype.slice.call(document.querySelectorAll('.js-city-link'));
  const citiesPopup = Array.prototype.slice.call(document.querySelectorAll('.js-popup[data-popup="cities"]'));
  const cityOutputBlock = Array.prototype.slice.call(document.querySelectorAll('.js-city-value'));
  const cityInput = document.querySelector('.js-city-value-input');

  if (!citiesLinks.length) return;

  citiesLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const { target } = e;
      const cityValue = target.innerText.trim();

      citiesPopup.forEach((el) => {
        const popup = el;
        popup.style.display = 'none';
        popup.classList.remove('is-open');
      });

      cityOutputBlock.forEach((el) => {
        const elOutput = el;
        elOutput.innerText = cityValue;
      });

      cityInput.value = cityValue;

      const lock = new Date();
      lock.setMonth(lock.getMonth() + 1);
      Cookies.setCookie('user_selected_city', cityValue, lock);
    });
  });

}
